import { render } from "./Prompt.vue?vue&type=template&id=7e0730c0"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"
script.render = render

export default script